import { style } from "@vanilla-extract/css";
import { primitiveTokens, semanticThemeTokens } from "../theme/ThemeTokens.css";

const { radio } = semanticThemeTokens;

export const radioGroup = style({
  display: "flex",
  flexDirection: "column",
  gap: primitiveTokens.sizing["4x"],
  selectors: {
    [`&[data-orientation="horizontal"]`]: {
      flexDirection: "row"
    }
  }
});

export const radioWrapper = style({
  display: "flex",
  alignItems: "center",
  position: "relative",
  columnGap: primitiveTokens.sizing["2x"],
  color: radio.label.textColor,
  fontSize: primitiveTokens.type.sm,
  fontWeight: "500",
  cursor: "pointer",
  selectors: {
    [`${radioGroup}[data-disabled] &`]: {
      cursor: "default",
      color: radio.label.disabled.textColor
    },
    [`${radioGroup}[aria-invalid="true"] &`]: {
      color: radio.label.invalid.textColor
    }
  }
});

export const radioItem = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 20,
  height: 20,
  borderRadius: "100%",
  borderWidth: primitiveTokens.borderWidth.default,
  borderStyle: "solid",
  borderColor: radio.borderColor,
  transition: primitiveTokens.animations.elementFade,
  backgroundColor: radio.backgroundColor,
  outline: "none",
  cursor: "inherit",

  selectors: {
    // Unchecked state
    "&:hover": {
      borderColor: radio.hover.borderColor
    },

    "&:focus": {
      boxShadow: primitiveTokens.colors.shadow.focusRing
    },

    "&:active": {
      backgroundColor: radio.active.backgroundColor,
      borderColor: radio.active.borderColor
    },

    "&[data-disabled]": {
      cursor: "default",
      backgroundColor: radio.disabled.backgroundColor,
      borderColor: radio.disabled.borderColor
    }
  }
});

export const radioIndicator = style({
  width: 20,
  height: 20,
  flexShrink: 0,
  backgroundColor: radio.checkmark.backgroundColor,
  borderRadius: "100%",
  border: `5px solid ${radio.checkmark.borderColor}`,

  selectors: {
    [`${radioItem}[data-state="checked"]:not([data-disabled]) &:hover`]: {
      borderColor: radio.checkmark.hover.borderColor
    },
    [`${radioItem}[data-state="checked"]:not([data-disabled]) &:active`]: {
      borderColor: radio.checkmark.active.borderColor
    },
    [`${radioItem}[data-disabled] &`]: {
      backgroundColor: radio.checkmark.disabled.backgroundColor,
      borderColor: radio.checkmark.disabled.borderColor
    }
  }
});
